import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import clsx from 'clsx';
import './companyList.scss';
import { RootState } from '../../store/store';
import { companyService } from '../../services/apiService';
import { CompanyApi } from '../../store/interfaces';
import CompanyForm from './companyForm';

const CompaniesPage: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const [companies, setCompanies] = useState<CompanyApi[]>([]);
  const [showForm, setShowForm] = useState<boolean>(false);
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      if (!user) {
        return;
      }

      try {
        const data = await companyService.getCompanies(user);
        setCompanies(data);
      } catch (error) {
        console.error('Get Companies error:', error);
      }
    }

    fetchData();
  }, [user]);

  if (!companies) {
    return <p>Fetching companies...</p>;
  }

  if (!user) {
    return <p>Not authorized</p>;
  }

  const submitForm = async (formData: any) => {
    if (user?.role !== 'SUPERADMIN') {
      return;
    }

    try {
      let response;
      if (params.id === '0' || !params.id) {
        // Create new company
        response = await companyService.createCompany(user, formData);
        console.log('response', response);
      } else {
        // Update existing company
        formData.id = Number(params.id);
        response = await companyService.updateCompany(user, Number(params.id), formData);
      }

      // Handle the response properly based on the return type
      if (response && 'id' in response) {
        // For createCompany, we get { id: number }
        const newCompany: CompanyApi = {
          id: response.id,
          name: formData.name,
          location: formData.location,
          code: formData.code || null,
          createdAt: new Date().toISOString(),
          serverId: formData.serverId || null
        };
        setCompanies([...companies.filter((c) => c.id !== formData.id), newCompany]);
      } else {
        // For updateCompany, we get CompanyApi
        setCompanies([...companies.filter((c) => c.id !== formData.id), response as CompanyApi]);
      }
      navigate('/companies');
    } catch (error) {
      console.error('Save Company Failed:', error);
    }
  };

  const viewCompanies = (
    <>
      <ul className="company-list">
        <li key="-1" className={clsx('company-item', 'company-header')}>
          <div className="company-name">Name</div>
          <div className="company-location">Location</div>
          <div className="company-view">Upload</div>
        </li>
        {companies.map((company, index) => {
          if (!company.id) {
            return <></>
          } else {
            return <li key={index} className="company-item">
              <div className="company-name">{company.name}</div>
              <div className="company-location">{company.location}</div>
              <div className="company-view">
                <Link to={`/companies/${company.id}`}>
                  <button>View</button>
                </Link>
              </div>
            </li>
          }
        })
        }
      </ul>
      {!companies.length && <h2>No companies found</h2>}
    </>
  );

  return (
    <>
      <div className="company-container">
        <div className={'company-topline'}>
          <button onClick={() => { setShowForm((formState) => !formState) }}>{showForm ? 'Hide Form' : 'Add New'}</button>
        </div>
        {showForm ? (
          <CompanyForm
            onSubmit={submitForm}
            initialData={companies.find((c) => c.id === Number(params.id))}
          />
        ) : (
          viewCompanies
        )}
      </div>
    </>
  );
};

export default CompaniesPage;
